module.exports = __webpack_public_path__ + "img/zimg7.c13cd66f.png";